<template>
  <el-form
    class="apply-card enterprise-bind"
    :model="ruleForm"
    :rules="rules"
    ref="formRef"
    label-width="140px"
  >
    <TitleTool title="关联企业" />
    <div class="pr10 pl10">
      <el-form-item label="关联方式">
        <el-radio-group v-model="mode">
          <el-radio-button label="pick">选择企业库中的企业</el-radio-button>
          <el-radio-button label="new">填写新企业</el-radio-button>
        </el-radio-group>
        <p class="bind-hint">选择已有企业时，这条内容直接挂到该企业。填写新企业时，先写入企业库，再把内容挂上去。</p>
      </el-form-item>

      <el-form-item v-if="mode === 'pick'" label="企业" required>
        <el-select
          v-model="enterpriseId"
          class="wp100"
          filterable
          remote
          clearable
          reserve-keyword
          placeholder="输入企业名称搜索"
          :remote-method="search"
          :loading="searching"
          @visible-change="onOpen"
          @change="onPick"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.enterpriseName"
            :value="item.id"
          >
            <span>{{ item.enterpriseName }}</span>
            <span v-if="item.enterpriseAbbreviation" class="bind-abbr">{{ item.enterpriseAbbreviation }}</span>
          </el-option>
        </el-select>
        <p v-if="picked" class="bind-picked">已选择：{{ picked.enterpriseName }}<template v-if="picked.enterpriseAbbreviation">（{{ picked.enterpriseAbbreviation }}）</template></p>
        <p v-if="pickError" class="bind-error">请选择企业</p>
      </el-form-item>

      <template v-else>
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业全称" prop="enterpriseName">
              <el-input v-model="ruleForm.enterpriseName" placeholder="请输入企业全称" maxlength="80" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业简称" prop="enterpriseAbbreviation">
              <el-input v-model="ruleForm.enterpriseAbbreviation" placeholder="请输入企业简称" maxlength="40" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="手机号或座机" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="ruleForm.email" placeholder="选填" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业类型" prop="typeOfEnterprise">
              <GsSelect v-model="ruleForm.typeOfEnterprise" class="wp100" placeholder="请选择企业类型" :options="typeOfEnterpriseEnum" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司产品" prop="companyProduct">
              <GsSelect v-model="ruleForm.companyProduct" class="wp100" multiple placeholder="请选择公司产品" :options="companyProductList" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="成立日期" prop="dateOfEstablishment">
              <GsDate v-model="ruleForm.dateOfEstablishment" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="DCMM等级" prop="dcmmRating">
              <GsSelect v-model="ruleForm.dcmmRating" class="wp100" filterable placeholder="请选择DCMM等级" :options="dcmmList" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="人员规模" prop="personnelSize">
              <el-input v-model="ruleForm.personnelSize" placeholder="请输入人员规模" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册资本" prop="registeredCapital">
              <el-input v-model="ruleForm.registeredCapital" placeholder="单位：万元" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="办公地址" prop="officeAddress">
              <el-input v-model="ruleForm.officeAddress" placeholder="请输入办公地址" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业官网" prop="url">
              <el-input v-model="ruleForm.url" placeholder="选填" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="行政区划" prop="administrativeDivision">
              <GsRegionSelect
                v-model="regionPath"
                class="wp100"
                placeholder="请选择省 / 市 / 区"
                @change="onRegionChange"
            />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="公司介绍" prop="companyProfile">
          <el-input
            v-model="ruleForm.companyProfile"
            type="textarea"
            placeholder="不超过 1500 字"
            maxlength="1500"
            show-word-limit
            :autosize="{ minRows: 3 }"
          />
        </el-form-item>
        <el-form-item label="数据凭证" prop="dealerCertificate">
          <GsUpload
            v-model="ruleForm.dealerCertificate"
            kind="image"
            :limit="6"
            accept="image/png,image/jpeg,image/jpg"
            add-text="上传凭证"
            tip="png / jpg / jpeg"
          />
        </el-form-item>
      </template>
    </div>
  </el-form>
</template>

<script>
import { getDataType } from '@/api/Layout/index.js'
import { enterpriseInfo, getEnterpriseList } from '@/api/Home/index.js'
import { enumType } from '@/utils/enum.js'
import { findNode, loadRegionTree } from '@/utils/region'
import ValidateReg from '@/utils/validateReg.js'
import GsUpload from '@/components/GsUpload/index.vue'

export default {
  name: 'EnterpriseBind',
  components: { GsUpload },
  data() {
    return {
      mode: 'pick',
      enterpriseId: null,
      options: [],
      picked: null,
      searching: false,
      pickError: false,
      opened: false,
      typeOfEnterpriseEnum: [],
      companyProductList: [],
      dcmmList: [],
      administrativeDivisionList: [],
      regionPath: [],
      regionTree: [],
      regionTree: [],
      ruleForm: {
        enterpriseName: '',
        enterpriseAbbreviation: '',
        phone: '',
        email: '',
        typeOfEnterprise: '',
        companyProduct: [],
        dateOfEstablishment: '',
        dcmmRating: '',
        personnelSize: '',
        registeredCapital: '',
        officeAddress: '',
        url: '',
        administrativeDivision: '',
        companyProfile: '',
        dealerCertificate: []
      },
      rules: {
        enterpriseName: [{ required: true, message: '请输入企业全称', trigger: ['blur', 'change'] }],
        enterpriseAbbreviation: [{ required: true, message: '请输入企业简称', trigger: ['blur', 'change'] }],
        phone: [
          { required: true, message: '请输入电话', trigger: ['blur', 'change'] },
          {
            pattern: /^(1[3-9]\d{9}|(0\d{2,3}-)?\d{7,8}|400[0-9]{7})$/,
            message: '请输入正确的电话号码格式',
            trigger: ['blur', 'change']
          }
        ],
        email: [{
          validator: (rule, value, callback) => {
            if (!value) return callback()
            if (new RegExp(ValidateReg.emailReg).test(value)) callback()
            else callback(new Error('邮箱格式不正确'))
          },
          trigger: ['blur', 'change']
        }],
        registeredCapital: [{
          validator: (rule, value, callback) => {
            if (!value) return callback()
            if (new RegExp(ValidateReg.moneyReg).test(value)) callback()
            else callback(new Error('注册资本只能输入正数'))
          },
          trigger: ['blur', 'change']
        }]
      }
    }
  },
  created() {
    this.loadDict('sys_enterprise_type', 'typeOfEnterpriseEnum')
    this.loadDict('sys_company_product', 'companyProductList')
    this.loadDict('sys_enterprise_dcmm_rating', 'dcmmList')
    loadRegionTree().then((tree) => {
      this.regionTree = tree || []
    }).catch(() => {
      this.regionTree = []
    })
  },
  methods: {
    /** 行政区划三级联动：存末级（区县）代码 */
    onRegionChange(path) {
      const list = Array.isArray(path) ? path : []
      this.regionPath = list
      const leaf = list.length ? findNode(this.regionTree, list[list.length - 1]) : null
      this.ruleForm.administrativeDivision = leaf ? String(leaf.value) : ''
    },
    async loadDict(type, key) {
      try {
        const res = await getDataType(type)
        if (res && res.data && res.data.length) this[key] = enumType(res.data)
      } catch (e) {}
    },
    onOpen(visible) {
      if (visible && !this.opened) {
        this.opened = true
        this.search('')
      }
    },
    search(query) {
      this.searching = true
      getEnterpriseList({
        enterpriseName: query || undefined,
        whetherPublish: '1',
        pageNum: 1,
        pageSize: 20
      }).then((res) => {
        const rows = (res && res.rows) || []
        const selected = this.picked && this.picked.id === this.enterpriseId ? this.picked : null
        this.options = selected && !rows.some((row) => row.id === selected.id)
          ? [selected].concat(rows)
          : rows
      }).catch(() => {
        this.options = this.picked ? [this.picked] : []
      }).finally(() => {
        this.searching = false
      })
    },
    onPick(id) {
      this.pickError = false
      this.picked = this.options.find((row) => row.id === id) || null
    },
    validate() {
      if (this.mode === 'pick') {
        this.pickError = !this.enterpriseId
        return Promise.resolve(!this.pickError)
      }
      return new Promise((resolve) => {
        this.$refs.formRef.validate((valid) => resolve(!!valid))
      })
    },
    resolveId() {
      if (this.mode === 'pick') {
        return Promise.resolve(this.enterpriseId)
      }
      const payload = Object.assign({}, this.ruleForm)
      payload.dealerCertificate = Array.isArray(payload.dealerCertificate)
        ? payload.dealerCertificate.join(',')
        : (payload.dealerCertificate || '')
      payload.companyProduct = JSON.stringify(payload.companyProduct || [])
      return enterpriseInfo(payload).then((res) => {
        if (res && res.code === 200 && res.data) return res.data
        return Promise.reject(new Error('enterprise'))
      })
    }
  }
}
</script>

<style scoped>
.bind-hint,
.bind-picked {
  display: block;
  flex-basis: 100%;
  width: 100%;
  margin: 8px 0 0;
  color: #5B6B82;
  font-size: 13px;
  line-height: 20px;
}
.bind-abbr {
  float: right;
  color: #8A97A8;
  font-size: 12px;
}
.bind-error {
  margin: 6px 0 0;
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
}
.wp100 {
  width: 100%;
}
@media (max-width: 960px) {
  .enterprise-bind :deep(.el-col) {
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }
  .enterprise-bind :deep(.el-form-item) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 12px;
  }
  .enterprise-bind :deep(.el-form-item__label) {
    width: auto !important;
    text-align: left !important;
    justify-content: flex-start !important;
    line-height: 1.35 !important;
    height: auto !important;
    padding: 0 0 4px !important;
    font-size: 12px !important;
    color: #64748b !important;
  }
  .enterprise-bind :deep(.el-form-item__content) {
    margin-left: 0 !important;
    width: 100% !important;
  }
  .enterprise-bind :deep(.el-radio-group) {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
  }
  .enterprise-bind :deep(.el-radio-button__inner) {
    padding: 8px 10px;
    font-size: 12px;
  }
}
</style>
